module.exports = __webpack_public_path__ + "img/cinta.0b12868c.png";